import { Order } from "@core/models/order.model";
import { NavigationState } from "@shared/models/navigation-state";

export class OrderServicesNavigationState extends NavigationState {
	override readonly className = "OrderServicesNavigationState";

	order?: Order;
	orderHasUnsavedChanges?: boolean = false;
	packageMap?: Map<string, string>;
}
